import { createFileRoute } from "@tanstack/react-router";
import TemplateSheetDetailPage from "@/pages/TemplateSheetDetailPage";

export const Route = createFileRoute("/learn/sheets/$slug")({
  head: () => ({ meta: [{"title": "Revision sheet library | System Atlas"}, {"name": "description", "content": "Review a structured course sheet and practise with System Atlas."}, {"property": "og:title", "content": "Revision sheet library | System Atlas"}, {"property": "og:description", "content": "Review a structured course sheet and practise with System Atlas."}, {"property": "og:type", "content": "website"}, {"name": "twitter:card", "content": "summary_large_image"}] }),
  component: TemplateSheetDetailPage,
});
